export const VOLUMETRIC_WEIGHT_DENOMINATOR = 6;
export const DEFAULT_USD_EXCHANGE_RATE = 1300;
export const DEFAULT_JPY_EXCHANGE_RATE = 8.5;
export const VOLUME_MARGIN_PERCENT = 0;

export const MAX_SHIP_FEE = 100_000_000; // 1억이 넘은 수치는 초과 무게이거나 배송비 산정에 오류가 있는 경우 (Back 에서는 해당되는 경우 max safe INT 를 리턴)
